/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsGetSuiteVersion } from "../../funcs/llmEvalsGetSuiteVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEvalSuiteVersionRequest$inboundSchema,
};

export const tool$llmEvalsGetSuiteVersion: ToolDefinition<typeof args> = {
  name: "llm-evals-get-suite-version",
  description: `Get an eval suite version

Retrieves an immutable eval suite version and its manifest.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsGetSuiteVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
